import { render, staticRenderFns } from "./return.vue?vue&type=template&id=7da8b4a3"
import script from "./return.vue?vue&type=script&lang=js"
export * from "./return.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7da8b4a3')) {
      api.createRecord('7da8b4a3', component.options)
    } else {
      api.reload('7da8b4a3', component.options)
    }
    module.hot.accept("./return.vue?vue&type=template&id=7da8b4a3", function () {
      api.rerender('7da8b4a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/base-data/after-sales-reason/return.vue"
export default component.exports